module.exports = __webpack_public_path__ + "assets/img/news19.8323e5fa.png";